// extracted by mini-css-extract-plugin
module.exports = {"pill-wrapper":"upgrade-pill-button__pill-wrapper___2Flof"};